// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__iPo-r","tooltip":"styles_tooltip__4XDDf","tooltipText":"styles_tooltipText__1grNV","info":"styles_info__LnPuQ"};